import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';
import {RoleTransformer} from '../helpers/enum/role-transformer';
import {Role} from './role';
import {InvitationStatus} from './invitation-status';
import {InvitationStatusTransformer} from '../helpers/enum/invitation-status-transformer';

@inheritSerialization(ModelBase)
export class Invitation extends ModelBase {
  public static readonly type = 'Invitation';
  public readonly type = Invitation.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('event_name')
  public eventName: string;

  @autoserializeAs('invitee_id')
  public inviteeId: number;

  @autoserializeAs('host_name')
  public hostName: string;

  @autoserializeAs(RoleTransformer, 'role')
  public role: Role = Role.Organisator;

  @autoserializeAs(InvitationStatusTransformer, 'status')
  public status: InvitationStatus;

  @autoserializeAs('first_name')
  public firstName: string;

  @autoserializeAs('last_name')
  public lastName: string;

  @autoserializeAs('email_address')
  public emailAddress: string;

  public name(): string {
    return this.firstName + ' ' + this.lastName;
  }
}
